import styled from "@emotion/styled";

const WrapperRoot = styled.div`
  padding-top: ${p => p.theme.space[6]}px;
  padding-bottom: ${({ isPopularQueries }) =>
    isPopularQueries ? "175px" : "40px"};
  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    padding-top: 0;
    padding-bottom: ${({ isPopularQueries }) =>
      isPopularQueries ? "241px" : "70px"};
  }
`;

const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.black};
  padding: 40px 18px ${p => (p.isPopularQueries ? "116px" : "40px")};
  border-radius: 20px;

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    padding: 113px 50px ${p => (p.isPopularQueries ? "180px" : "113px")};
    border-radius: 35px;
  }
`;

const ContentBox = styled.div`
  max-width: 980px;
  margin: 0 auto;
`;

export { WrapperRoot, Wrapper, ContentBox };
